import { Node, Path } from 'slate';

export const EXERCISE_SHORT_ANSWER = 'exercise-short-answer';
export const EXERCISE_SHORT_ANSWER_QUESTIONS = 'exercise-short-answer-questions';
export const EXERCISE_SHORT_ANSWER_QUESTION = 'exercise-short-answer-question';
export const EXERCISE_SHORT_ANSWER_BLANK = 'exercise_short_answer_blank';
export const PARAGRAPH_TOGGLE = 'paragraph-toggle';

export type ExerciseShortAnswerOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type ExerciseShortAnswerNode = {
  startFrom: number;
  isLoginRequired?: boolean;
} & Node;

export type ExerciseShortAnswerEntry = [ExerciseShortAnswerNode, Path];

export type ExerciseShortAnswerQuestionOptions = {
  isReadOnly?: boolean;
};

export type CreteShortAnswerQuestionOptions = {
  question?: string;
  explanation?: string;
  options?: string[];
  correctOptions?: string[];
};

export const SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES = {
  GUIDE: 'short-answer-guide',
  QUESTION: 'short-answer-question',
  EXPLANATION: 'short-answer-explanation',
};
